export default {
  btnText: "Сменить компанию",
  popupTitle: "Выбор компании",

  pluralize: ["компания", "компании", "компаний"],

  modal: {
    totalCompanies: "Всего {amount}",
    searchPlaceholder: "Поиск компании",
    viewByList: "Списком",
    viewByCards: "Карточками",

    companyProfile: "Профиль компании",
    companyProfileFilled: "Заполнен",
    companyProfileNotFilled: "Не заполнен",
    catalogApplication: "Заявка в каталог",
    catalogApplicationSent: "Отправлена",
    catalogApplicationNotSent: "Не отправлена",

    participantPasses: "Удостоверения участника",
    carPasses: "Пропуск на автомобиль"
  }
};
